module.exports = __webpack_public_path__ + "static/media/ship-bg-mobile-galaxy.21d0ee81.jpg";